export default {
  "about": "عنا",
  "about_title": "من نحن",
  "access_secret": "سر الوصول",
  "access_token": "رمز الوصول",
  "accessibility_animations": "الرسوم المتحركة",
  "accessibility_contrast": "التباين",
  "accessibility_font_size": "حجم الخط",
  "accessibility_title": "الوصول",
  "actions": "الإجراءات",
  "active": "نشط",
  "active_ads": "الإعلانات النشطة",
  "active_campaigns": "الحملات النشطة",
  "ad_code_placeholder": "<script>...</script> أو رمز فتحة AdSense",
  "ad_format": "تنسيق الإعلان",
  "ad_formats": "أشكال الإعلانات",
  "ad_management": "إدارة الإعلانات",
  "ad_position_settings": "إعدادات مواقع الإعلانات",
  "ad_price_list": "قائمة أسعار الإعلانات",
  "ad_pricing_formats_campaigns": "التسعير، التنسيقات، الحملات والتتبع",
  "add": "إضافة",
  "add_api_keys": "إضافة مفاتيح API في علامة التبويب التكوين",
  "address": "العنوان",
  "admin": "إدارة",
  "adminPanel": "لوحة الإدارة",
  "admin_ab_testing_title": "اختبار A/B",
  "admin_accent": "تمييز",
  "admin_accent_color": "لون التمييز",
  "admin_action": "إجراء",
  "admin_activate": "تفعيل",
  "admin_active_feeds": "الخلاصات النشطة",
  "admin_active_label": "نشط",
  "admin_active_now": "نشيط الآن",
  "admin_active_subscribers": "المشتركين النشطين",
  "admin_ad_performance": "أداء الإعلان",
  "admin_add_feed": "أضف تغذية",
  "admin_add_tag": "إضافة وسم",
  "admin_admins": "المدراء",
  "admin_advertisements": "إعلانات",
  "admin_advertiser_email": "البريد الإلكتروني للمعلن",
  "admin_advertiser_name": "اسم المعلن",
  "admin_affiliate_links": "روابط التسويق بالعمولة",
  "admin_ai_content_title": "معالجة المحتوى بالذكاء الاصطناعي",
  "admin_ai_prompt_settings": "إعدادات موجه ونموذج الذكاء الاصطناعي",
  "admin_analytics_title": "التحليلات",
  "admin_api_latency": "زمن استجابة API",
  "admin_api_server": "خادم API",
  "admin_article_actions": "الإجراءات",
  "admin_article_category": "الفئة",
  "admin_article_published": "منشور",
  "admin_article_selector": "محدد المقالة (CSS، مثل article.news)",
  "admin_article_views": "المشاهدات",
  "admin_articles_count": "المقالات",
  "admin_articles_title": "المقالات",
  "admin_author_change_failed": "فشل تغيير المؤلف.",
  "admin_authors_title": "المؤلفون",
  "admin_auto": "تلقائي",
  "admin_auto_save_draft": "حفظ تلقائي كمسودة",
  "admin_avg_seo_score": "متوسط درجة SEO",
  "admin_bio": "السيرة الذاتية",
  "admin_blog_manage": "إدارة منشورات المدونة بمحرر غني بالمحتوى",
  "admin_blog_title": "مدونة",
  "admin_brand_theme": "العلامة التجارية والمظهر",
  "admin_branding_desc": "تخصيص مظهر الموقع (للمشرفين فقط)",
  "admin_branding_title": "وحدة إعادة العلامة التجارية",
  "admin_breaking_ticker": "شريط الأخبار العاجلة",
  "admin_browser": "المتصفح",
  "admin_browsers": "المتصفحات",
  "admin_bug_reports": "تقارير الأخطاء",
  "admin_bulk_delete_failed": "فشل الحذف المجمّع.",
  "admin_bulk_operations": "عمليات مجمعة",
  "admin_categories_grid": "شبكة الفئات",
  "admin_choose_gallery": "اختر من المعرض",
  "admin_churn_prediction": "التنبؤ بالفقدان",
  "admin_classic_portal": "بوابة الأخبار الكلاسيكية",
  "admin_classifieds": "الإعلانات المبوبة",
  "admin_clear_log": "مسح السجل",
  "admin_click_button": "انقر على الزر",
  "admin_collection_stats": "إحصائيات المجموعة",
  "admin_color_scheme": "نظام الألوان",
  "admin_columnist": "كاتب عمود",
  "admin_comments": "التعليقات",
  "admin_competitor_monitoring": "مراقبة المنافسين",
  "admin_confirm_action": "هل أنت متأكد؟",
  "admin_content_calendar_title": "تقويم المحتوى",
  "admin_content_filter": "شروط تصفية المحتوى",
  "admin_content_stats": "إحصائيات المحتوى",
  "admin_contributor": "مساهم",
  "admin_coordinates": "الإحداثيات",
  "admin_copy_ip": "نسخ عنوان IP",
  "admin_copy_text": "نسخ",
  "admin_core_services": "الخدمات الأساسية",
  "admin_countries": "البلدان",
  "admin_cpc": "CPC (EUR)",
  "admin_crawl_now": "زحف الآن",
  "admin_create_author": "إنشاء مؤلف",
  "admin_create_manage_promo": "إنشاء وإدارة الرموز الترويجية",
  "admin_create_voucher": "إنشاء قسيمة",
  "admin_custom_meta": "ميتا مخصصة",
  "admin_dashboard_title": "لوحة التحكم",
  "admin_database": "قاعدة بيانات",
  "admin_db_backup": "نسخ قاعدة البيانات احتياطياً",
  "admin_db_latency": "زمن استجابة قاعدة البيانات",
  "admin_db_name": "اسم قاعدة البيانات",
  "admin_db_size": "حجم قاعدة البيانات",
  "admin_default": "افتراضي",
  "admin_default_language": "اللغة الافتراضية",
  "admin_device": "الجهاز",
  "admin_devices": "الأجهزة",
  "admin_discount": "خصم",
  "admin_disk_usage": "استخدام القرص",
  "admin_docs_api_ref": "مرجع API",
  "admin_docs_download_pdf": "تحميل PDF",
  "admin_docs_faq": "الأسئلة المتكررة",
  "admin_docs_getting_started": "البدء",
  "admin_docs_implemented": "تم التنفيذ",
  "admin_docs_no_pages": "لا توجد صفحات توثيق حتى الآن",
  "admin_docs_order": "ترتيب",
  "admin_docs_title": "التوثيق",
  "admin_doktor_earnings": "أرباح Doktor",
  "admin_draft_articles": "المقالات المسودة",
  "admin_dynamic_pricing": "التسعير الديناميكي",
  "admin_edit_in_cms": "تحرير في CMS",
  "admin_editor_role": "محرر",
  "admin_export_csv": "تصدير CSV",
  "admin_favicon": "الأيقونة المفضلة",
  "admin_feed_crawler": "جالب الخلاصات",
  "admin_feed_name": "اسم التغذية",
  "admin_feed_url": "رابط التغذية",
  "admin_feeds_title": "خلاصات RSS",
  "admin_file": "ملف",
  "admin_fixed_amount": "مبلغ ثابت",
  "admin_frozen": "مجمد",
  "admin_full_name": "الاسم الكامل",
  "admin_general": "عام",
  "admin_google_search_console": "واجهة بحث Google",
  "admin_grade": "الدرجة",
  "admin_health_title": "فحص الصحة",
  "admin_high_leads": "عملاء ذو قيمة عالية",
  "admin_import_title": "منصة استيراد Croatia Times",
  "admin_index_now": "IndexNow",
  "admin_integrations": "التكاملات",
  "admin_job_postings": "إعلانات الوظائف",
  "admin_joined": "انضم",
  "admin_keywords": "الكلمات المفتاحية",
  "admin_landing_title": "صفحات الهبوط",
  "admin_last_submissions": "آخر الإرسالات",
  "admin_live_analytics": "التحليلات المباشرة",
  "admin_live_analytics_title": "تحليلات حية",
  "admin_llm_model": "نموذج LLM",
  "admin_manage_feeds": "إدارة الخلاصات",
  "admin_mass_management": "إدارة المقالات بشكل جماعي",
  "admin_max_articles": "الحد الأقصى للمقالات",
  "admin_media_storage": "التخزين الإعلامي",
  "admin_memory": "الذاكرة",
  "admin_menu_manager": "إدارة القائمة",
  "admin_meta_description": "وصف ميتا",
  "admin_monetization_title": "لوحة إدارة التسييل",
  "admin_mysql_db": "قاعدة بيانات MySQL",
  "admin_mysql_host": "مضيف MySQL",
  "admin_nav_ab_testing": "اختبار A/B",
  "admin_nav_ads": "إدارة الإعلانات",
  "admin_nav_ads_report": "تقرير الإعلانات",
  "admin_nav_adsense": "إعدادات AdSense",
  "admin_nav_advanced_analytics": "تحليلات متقدمة",
  "admin_nav_affiliates": "روابط التسويق بالعمولة",
  "admin_nav_ai_content": "معالجة المحتوى بواسطة AI",
  "admin_nav_amp": "AMP و اكتشاف جوجل",
  "admin_nav_analytics": "التحليلات",
  "admin_nav_analytics_ai": "التحليلات والذكاء الصناعي",
  "admin_nav_articles": "مقالات",
  "admin_nav_audit_log": "سجل التدقيق",
  "admin_nav_authors": "المؤلفون",
  "admin_nav_blog": "مدونة",
  "admin_nav_branding": "إعادة العلامة التجارية",
  "admin_nav_breaking_news": "الأخبار العاجلة / الفلاش",
  "admin_nav_bulk_operations": "عمليات بالجملة",
  "admin_nav_categories": "الفئات",
  "admin_nav_chat_sessions": "الجلسات الحوارية",
  "admin_nav_churn_prediction": "توقع الفقدان",
  "admin_nav_classifieds": "الإعلانات المبوبة",
  "admin_nav_comments": "تعليقات",
  "admin_nav_competitor_monitoring": "مراقبة المنافسين",
  "admin_nav_content": "المحتوى",
  "admin_nav_content_calendar": "تقويم المحتوى",
  "admin_nav_county_map": "خريطة المحافظة",
  "admin_nav_crypto": "أداة العملات الرقمية",
  "admin_nav_dashboard": "لوحة التحكم",
  "admin_nav_db_backup": "قاعدة البيانات",
  "admin_nav_docs": "التوثيق",
  "admin_nav_doktor_earnings": "أرباح دكتور",
  "admin_nav_duplicate_detection": "اكتشاف التكرارات",
  "admin_nav_editorial": "التحرير",
  "admin_nav_editorial_workflow": "سير عمل التحرير",
  "admin_nav_email_campaigns": "حملات البريد الإلكتروني",
  "admin_nav_feeds": "خلاصات RSS",
  "admin_nav_finance": "المالية",
  "admin_nav_health": "صحة النظام",
  "admin_nav_heatmaps": "خارطة حرارية للقراءة",
  "admin_nav_import": "الاستيراد",
  "admin_nav_invoices": "الفواتير",
  "admin_nav_job_ads": "إعلانات الوظائف",
  "admin_nav_landing_pages": "صفحات الهبوط",
  "admin_nav_live_analytics": "تحليلات حية",
  "admin_nav_management": "الإدارة",
  "admin_nav_marketing": "التسويق",
  "admin_nav_media": "وسائط",
  "admin_nav_menu_manager": "إدارة القوائم",
  "admin_nav_micropayments": "المدفوعات الصغيرة",
  "admin_nav_monetization": "تحقيق الدخل",
  "admin_nav_newsletter": "النشرة الإخبارية",
  "admin_nav_newsletter_digest": "ملخص النشرة الإخبارية",
  "admin_nav_pages": "الصفحات",
  "admin_nav_payments": "المدفوعات",
  "admin_nav_performance_forecast": "توقعات الأداء",
  "admin_nav_photo_verification": "التحقق من الصورة",
  "admin_nav_portal_toggle": "إدارة البوابة",
  "admin_nav_portals": "البوابات",
  "admin_nav_pricing": "التسعير",
  "admin_nav_promo_codes": "رموز ترويجية",
  "admin_nav_push_notifications": "الإشعارات الفورية",
  "admin_nav_quizzes": "اختبارات",
  "admin_nav_recommendations": "توصيات المحتوى",
  "admin_nav_reports": "تقارير المحتوى",
  "admin_nav_sanitization": "تنقية المحتوى",
  "admin_nav_scheduler": "جدولة المحتوى",
  "admin_nav_security": "الأمن",
  "admin_nav_seo_dashboard": "لوحة تحكم SEO",
  "admin_nav_seo_distribution": "التوزيع و SEO",
  "admin_nav_series": "سلسلة المقالات",
  "admin_nav_settings": "الإعدادات",
  "admin_nav_social": "وسائل التواصل الاجتماعي",
  "admin_nav_social_scheduler": "جدولة المجتمع",
  "admin_nav_sponsored": "برعاية",
  "admin_nav_sponsored_marketplace": "سوق الرعاية",
  "admin_nav_subscriptions": "الاشتراكات",
  "admin_nav_surveys": "الاستطلاعات",
  "admin_nav_syndication": "واجهة برمجة تطبيقات التوزيع",
  "admin_nav_system": "النظام",
  "admin_nav_tips": "نصائح / تبرعات",
  "admin_nav_translations": "الترجمات",
  "admin_nav_ugc_review": "محتوى المواطنين",
  "admin_nav_users": "المستخدمون",
  "admin_nav_users_subscriptions": "المستخدمون والاشتراكات",
  "admin_nav_versioning": "تاريخ الإصدارات",
  "admin_nav_vibeposao": "بوابة Times Posao",
  "admin_nav_vouchers": "قسائم / خصومات",
  "admin_nav_widgets": "الأدوات / الكتالوجات",
  "admin_new_author_name": "اسم مؤلف جديد...",
  "admin_new_post": "منشور جديد",
  "admin_no_data": "لا توجد بيانات متاحة",
  "admin_no_icon": "لا يوجد أيقونة",
  "admin_no_logo": "لا يوجد شعار",
  "admin_no_pending_reports": "لا تقارير معلقة",
  "admin_no_published_articles": "لا توجد مقالات منشورة",
  "admin_password_field": "كلمة المرور",
  "admin_performance_forecast": "توقع الأداء",
  "admin_photo_verification": "التحقق من الصور",
  "admin_plan": "الخطة",
  "admin_platform_audit": "مراجعة النظام",
  "admin_portal_toggle": "إدارة البوابة",
  "admin_premium_users": "المستخدمون المميزون",
  "admin_primary": "أساسي",
  "admin_published_articles": "المقالات المنشورة",
  "admin_published_today": "نُشر اليوم",
  "admin_quick_actions": "إجراءات سريعة",
  "admin_recent_articles": "المقالات الحديثة",
  "admin_role_change_failed": "فشل في تحديث الدور.",
  "admin_search_placeholder": "بحث في لوحة الإدارة...",
  "admin_secondary": "ثانوي",
  "admin_seo_desc": "تحسين المحتوى، إدارة GSC وخرائط المواقع",
  "admin_seo_title": "لوحة تحكم SEO",
  "admin_service_requests": "طلبات الخدمة",
  "admin_set_category": "تعيين الفئة",
  "admin_set_featured": "تعيين كمميز",
  "admin_settings_saved": "تم حفظ الإعدادات",
  "admin_settings_title": "الإعدادات",
  "admin_short_desc": "وصف قصير",
  "admin_site_identity": "هوية الموقع",
  "admin_site_logo": "شعار الموقع",
  "admin_site_settings": "إعدادات الموقع",
  "admin_sponsored_marketplace": "السوق المدعوم",
  "admin_sponsored_title": "مقالات برعاية",
  "admin_surveys_title": "استطلاعات",
  "admin_system_status": "حالة النظام",
  "admin_table_header_actions": "الإجراءات",
  "admin_table_header_date": "التاريخ",
  "admin_table_header_email": "البريد الإلكتروني",
  "admin_table_header_name": "الاسم",
  "admin_table_header_status": "الحالة",
  "admin_thumbnail_settings_saved": "تم حفظ إعدادات الصورة المصغرة",
  "admin_top_articles_views": "المقالات الأعلى مشاهدة",
  "admin_total_articles": "إجمالي المقالات",
  "admin_total_users": "إجمالي المستخدمين",
  "admin_total_views": "إجمالي المشاهدات",
  "admin_ugc_review": "مراجعة المحتوى المقدم من المستخدمين",
  "admin_username": "اسم المستخدم",
  "admin_users_title": "المستخدمون",
  "admin_version_history": "سجل الإصدارات",
  "admin_view_health_report": "عرض تقرير الصحة الكامل",
  "admin_write_new_article": "اكتب مقال جديد",
  "adsense_client_id": "AdSense Client ID",
  "adsense_enable_disable": "تمكين/تعطيل جميع تقديمات الإعلانات التلقائية",
  "adsense_global_toggle": "تبديل AdSense العام",
  "adsense_script_code": "رمز سكريبت AdSense",
  "adsense_settings": "AdSense ومواقع الإعلانات",
  "advertise_contact_sales": "اتصل بالمبيعات",
  "advertise_get_started": "ابدأ",
  "advertise_reach_audience": "الوصول إلى جمهورنا",
  "advertise_title": "أعلن معنا",
  "advertiser": "المعلن",
  "advertiser_analytics": "تحليلات المعلن",
  "advertiser_email": "البريد الإلكتروني للمعلن",
  "advertising": "الإعلانات",
  "advertising_cookies": "كوكيز الإعلانات",
  "affiliate_title": "برنامج التسويق بالعمولة",
  "ago": "منذ",
  "ai_image_prompt": "مطالبة الصورة AI",
  "all": "الكل",
  "all_categories": "كل الفئات",
  "all_jobs": "جميع الوظائف",
  "all_rights": "جميع الحقوق محفوظة",
  "all_status": "كل الحالات",
  "all_types": "كل الأنواع",
  "alpha": "ألفا",
  "alreadyHaveAccount": "هل لديك حساب بالفعل؟",
  "already_have_account": "لديك حساب؟",
  "analytics": "تحليلات",
  "analytics_cookies": "كوكيز التحليلات",
  "api_key": "مفتاح API",
  "api_secret": "سر API",
  "applications": "الطلبات",
  "apply": "تطبيق",
  "apply_now": "تقدم الآن",
  "approve": "الموافقة",
  "approved": "موافق عليه",
  "archive": "أرشيف",
  "archived": "مؤرشف",
  "article_content": "محتوى المقال",
  "article_title": "عنوان المقال...",
  "article_views": "المشاهدات",
  "author": "الكاتب",
  "auto_posting": "النشر التلقائي ودمج الوسائط الاجتماعية",
  "auto_share_articles": "مشاركة المقالات المنشورة تلقائيًا على المنصات المتصلة",
  "avg_ctr": "متوسط CTR",
  "back": "رجوع",
  "basic": "أساسي",
  "be_respectful": "كن محترمًا ومهذبًا مع المستخدمين الآخرين وموضوعات المقالات",
  "beta": "بيتا",
  "book_ad": "حجز إعلان",
  "booking_details": "تفاصيل الحجز",
  "breaking": "عاجل",
  "bug_description": "وصف الخطأ",
  "business": "أعمال",
  "business_account_id": "معرف الحساب التجاري",
  "buyer": "المشتري",
  "campaign_details": "تفاصيل الحملة",
  "campaigns": "الحملات",
  "cancel": "إلغاء",
  "caption": "التعليق",
  "categories": "الفئات",
  "category": "الفئة",
  "category_distribution": "توزيع الفئات",
  "category_push_subscribers": "مشتركي إشعارات الفئة",
  "chatbot_placeholder": "اكتب رسالة...",
  "chatbot_send": "إرسال",
  "chatbot_title": "مساعد الدردشة",
  "choose_plan": "اختر خطتك",
  "city": "المدينة",
  "classifieds": "إعلانات",
  "classifieds_title": "الإعلانات المبوبة",
  "clear": "مسح",
  "click_rate": "معدل النقر",
  "click_url": "انقر على URL (الوجهة)",
  "clicks": "النقرات",
  "client_id": "معرف العميل",
  "client_secret": "سر العميل",
  "close": "إغلاق",
  "code": "رمز",
  "commenting_rules": "قواعد التعليق",
  "comments": "التعليقات",
  "companies": "الشركات",
  "company": "الشركة",
  "compose_social_post": "كتابة منشور اجتماعي",
  "configure": "تكوين",
  "configure_position": "إعداد كل موضع مع صورة بانر مخصصة أو رمز إعلان",
  "confirm": "تأكيد",
  "confirm_delete": "هل أنت متأكد أنك تريد الحذف؟",
  "confirm_password": "تأكيد كلمة المرور",
  "congratulations": "تهانينا",
  "contact": "اتصل بنا",
  "contact_title": "اتصل",
  "contact_us": "اتصل بنا",
  "content": "محتوى",
  "cookies": "ملفات تعريف الارتباط",
  "cookies_title": "سياسة الكوكيز",
  "copy": "نسخ",
  "copyright": "حقوق النشر",
  "copyright_notice": "حقوق النشر",
  "count": "عدد",
  "country": "الدولة",
  "cpm": "CPM",
  "create": "إنشاء",
  "create_first_ad": "أنشئ إعلانك الأول",
  "crypto_change_24h": "التغيير خلال ٢٤ ساعة",
  "crypto_market_cap": "القيمة السوقية",
  "crypto_price": "السعر",
  "crypto_widget_title": "تشفير",
  "ctr": "CTR",
  "culture": "ثقافة",
  "current_plan": "الخطة الحالية",
  "custom_ad_code": "رمز الإعلان المخصص",
  "custom_banner_url": "عنوان URL للبانر المخصص",
  "custom_range": "نطاق مخصص",
  "daily_budget": "الميزانية اليومية",
  "daily_performance": "الأداء اليومي",
  "dark_mode": "الوضع الداكن",
  "data_viz_title": "تخيل البيانات",
  "date": "التاريخ",
  "dating_add_video": "أضف فيديو قصير بحيث يمكن للمرشحين المحتملين التعرف عليك بشكل أفضل",
  "dating_block": "حظر",
  "dating_boosts": "تعزيزات",
  "dating_city": "مدينة",
  "dating_next": "التالي",
  "dating_personality_quiz": "اختبار الشخصية",
  "dating_quiz_completed": "اكتمل اختبار الشخصية",
  "dating_users": "المستخدمون",
  "dating_verify_identity": "تحقق من أنك شخص حقيقي",
  "dating_voice_message": "رسالة صوتية",
  "days": "أيام",
  "delete": "حذف",
  "delete_failed": "فشل الحذف.",
  "deleted_successfully": "تم الحذف بنجاح",
  "deprecated": "مهجور",
  "describe_thumbnail": "وصف صورة المصغرة لتوليد...",
  "description": "الوصف",
  "deselect_all": "إلغاء تحديد الكل",
  "desktop": "سطح المكتب",
  "details": "التفاصيل",
  "dimensions": "الأبعاد",
  "disabled": "معطل",
  "dismiss": "تجاهل",
  "documentation": "وثائق",
  "doktor_add_document": "إضافة مستند",
  "doktor_biography": "السيرة الذاتية",
  "doktor_birth_date": "تاريخ الميلاد",
  "doktor_chat": "دردشة",
  "doktor_control_date": "تاريخ المتابعة",
  "doktor_date": "التاريخ",
  "doktor_diagnosis": "التشخيص",
  "doktor_enter_name_specialization": "أدخل الاسم وتخصص واحد على الأقل",
  "doktor_enter_patient_name": "أدخل اسم المريض",
  "doktor_license_number": "رقم الترخيص",
  "doktor_panel": "لوحة الطبيب",
  "doktor_patient_name": "اسم المريض",
  "doktor_text_min_chars": "يجب أن يحتوي النص على 50 حرفاً على الأقل",
  "doktor_waiting_room": "غرفة الانتظار",
  "dont_have_account": "ليس لديك حساب؟",
  "download": "تنزيل",
  "draft": "مسودة",
  "duplicate": "تكرار",
  "duration_days": "المدة (بالأيام)",
  "economy": "الاقتصاد",
  "edit": "تعديل",
  "electronics": "إلكترونيات",
  "email": "البريد الإلكتروني",
  "email_address": "البريد الإلكتروني",
  "email_campaigns": "حملات البريد الإلكتروني",
  "email_clicks": "نقرات البريد",
  "email_content": "محتوى البريد الإلكتروني...",
  "email_opens": "فتح البريد",
  "email_placeholder": "بريدك الإلكتروني",
  "email_subject": "موضوع البريد الإلكتروني",
  "employer": "صاحب العمل",
  "enabled": "ممكّن",
  "end_date": "تاريخ الانتهاء",
  "enter_advertiser_email": "أدخل بريدك الإلكتروني للمعلن...",
  "enter_email_to_view": "أدخل بريدك الإلكتروني للمعلن أعلاه لعرض أداء حملتك",
  "entertainment": "ترفيه",
  "error": "خطأ",
  "error_deleting": "خطأ في الحذف",
  "error_generating_digest": "خطأ في توليد الملخص",
  "error_loading": "خطأ في التحميل",
  "error_saving": "خطأ في الحفظ",
  "error_saving_settings": "خطأ في الحفظ",
  "error_sending": "خطأ في الإرسال",
  "error_uploading": "خطأ في الرفع",
  "error_uploading_photo": "فشل في تحميل الصورة",
  "events_calendar": "تقويم الأحداث",
  "excerpt_summary": "مقتطف / ملخص",
  "experimental": "تجريبي",
  "export": "تصدير",
  "export_data": "تصدير البيانات",
  "facebook": "فيسبوك",
  "facebook_login_unavailable": "عملية تسجيل الدخول عبر فيسبوك غير متاحة",
  "failed_post_comment": "فشل في إضافة التعليق.",
  "feature_flags": "خصائص المميزات",
  "feature_job": "ميزة الوظيفة",
  "featured": "مميز",
  "featured_article": "مقال مميز",
  "featured_duration": "مدة الظهور المميز",
  "featured_image": "صورة مميزة",
  "featured_jobs": "وظائف مميزة",
  "feedback": "تعليقات",
  "filter": "تصفية",
  "filter_terms_saved": "تم حفظ شروط التصفية!",
  "find_jobs": "ابحث عن وظائف",
  "first": "الأولى",
  "first_process_publish": "معالجة ونشر المقال أولاً",
  "footer_ai": "يستخدم هذا البوابة مساعدة الذكاء الاصطناعي",
  "footer_ai_notice": "تم إنشاء بعض المحتوى بمساعدة الذكاء الاصطناعي - أبلغ عن المشكلات",
  "footer_cat_business": "الأعمال",
  "footer_cat_culture": "الثقافة",
  "footer_cat_health": "الصحة",
  "footer_cat_news": "الأخبار",
  "footer_cat_politics": "السياسة",
  "footer_cat_sports": "الرياضة",
  "footer_cat_technology": "التكنولوجيا",
  "footer_categories": "التصنيفات",
  "footer_copyright": "2026 Liber Nostra d.o.o. جميع الحقوق محفوظة.",
  "footer_description": "Croatia Times هو مصدر الثقة لديك للأخبار العاجلة والتحليل المتعمق والقصص الجذابة من كرواتيا وما وراءها.",
  "footer_developed_by": "تم التطوير والصيانة بحب من قبل",
  "footer_email_placeholder": "عنوان بريدك الإلكتروني",
  "footer_here": "هنا",
  "footer_hosted_by": "مستضاف بواسطة",
  "footer_link_about": "من نحن",
  "footer_link_advertise": "الإعلان",
  "footer_link_contact": "اتصل بنا",
  "footer_link_cookies": "الكوكيز",
  "footer_link_imprint": "البصمة",
  "footer_link_privacy": "سياسة الخصوصية",
  "footer_link_submit_news": "إرسال خبر",
  "footer_newsletter_text": "اشترك في نشرتنا الإخبارية",
  "footer_quick_links": "روابط سريعة",
  "footer_stay_informed": "ابقَ على اطلاع",
  "footer_subscribe": "اشتراك",
  "for_you_personalized": "محتوى مخصص بناءً على اهتماماتك",
  "for_you_title": "لأجلك",
  "forgot_password": "نسيت كلمة المرور؟",
  "free": "مجاني",
  "free_plan": "مجاني",
  "from": "من",
  "full_time": "دوام كامل",
  "general": "عام",
  "goodbye": "وداعًا",
  "hashtags": "الوسوم",
  "hashtags_placeholder": "#news #croatia...",
  "header_auto_schedule_active": "الجدولة التلقائية مفعلة",
  "header_forecast": "التوقعات",
  "header_humidity": "الرطوبة",
  "header_live": "مباشر",
  "header_portals_label": "البوابات",
  "header_weather_humidity": "الرطوبة",
  "header_weather_wind": "الرياح",
  "header_wind": "الرياح",
  "health": "صحة",
  "hello": "مرحبًا",
  "help": "مساعدة",
  "home": "الرئيسية",
  "home_podcast_title": "التحديث الأسبوعي للتقنية: الذكاء الاصطناعي في الشركات الناشئة في كرواتيا",
  "home_video_title": "داخل زغرب: وثائقي عن فن الشارع",
  "hours": "ساعات",
  "import": "استيراد",
  "impressions": "مرات الظهور",
  "imprint": "بصمة",
  "imprint_title": "الطباعة",
  "inactive": "غير نشط",
  "info": "معلومة",
  "instagram": "إنستغرام",
  "invalid_code": "رمز غير صالح. حاول مرة أخرى.",
  "items_selected": "العناصر المحددة",
  "job_categories": "فئات الوظائف",
  "job_postings": "إعلانات الوظائف",
  "job_seeker": "الباحث عن عمل",
  "jobs": "وظائف",
  "just_now": "الآن",
  "language": "اللغة",
  "last": "الأخيرة",
  "latest_news": "آخر الأخبار",
  "legal": "قانوني",
  "lifestyle": "نمط الحياة",
  "lifetime": "مدى الحياة",
  "light_mode": "الوضع الفاتح",
  "linked_email_campaign": "مرتبط بحملة بريد إلكتروني",
  "linkedin": "لينكد إن",
  "live_stream": "بث مباشر",
  "load_more": "تحميل المزيد",
  "loading": "جاري التحميل...",
  "local": "محلي",
  "location": "الموقع",
  "login": "تسجيل الدخول",
  "logout": "خروج",
  "loyalty_available_points": "النقاط المتاحة",
  "loyalty_available_rewards": "المكافآت المتاحة",
  "loyalty_badges": "شارات",
  "loyalty_consecutive_days": "أيام متتالية",
  "loyalty_error": "خطأ",
  "loyalty_leaderboard": "لوحة المتصدرين",
  "loyalty_leaderboard_empty": "لوحة المتصدرين فارغة",
  "loyalty_rewards": "المكافآت",
  "loyalty_used_rewards": "المكافآت المستخدمة",
  "majstor_categories": "الفئات",
  "majstor_city": "مدينة",
  "majstor_company_name": "اسم الشركة *",
  "majstor_flexible": "مرن",
  "majstor_max_budget": "أقصى ميزانية (EUR)",
  "majstor_min_budget": "أقل ميزانية (EUR)",
  "majstor_my_requests": "طلباتي",
  "majstor_request_title": "عنوان الطلب *",
  "majstor_service_categories": "فئات الخدمة",
  "majstor_urgent": "عاجل",
  "manage": "إدارة",
  "manage_bookings": "إدارة حجوزات المعلنين",
  "mark_as_read": "تحديد كمقروء",
  "marketing_dashboard": "لوحة تسويق",
  "marketing_live_metrics": "مقاييس الأداء المباشرة لـ Croatia Times",
  "marketing_published_articles": "المقالات المنشورة",
  "marketing_registered_users": "المستخدمون المسجلون",
  "marketing_today_views": "مشاهدات اليوم",
  "marketing_total_views": "إجمالي مشاهدات الصفحة",
  "minutes": "دقائق",
  "missing_translations": "الترجمات المفقودة",
  "mobile": "الهاتف المحمول",
  "more": "المزيد",
  "most_popular": "الأكثر شعبية",
  "most_read": "الأكثر قراءة",
  "move": "نقل",
  "must_be_logged_in_purchase": "يجب أن تقوم بتسجيل الدخول لشراء مقال",
  "myProfile": "ملفي الشخصي",
  "my_applications": "طلباتي",
  "name": "الاسم",
  "new": "جديد",
  "new_article": "مقال جديد",
  "new_campaign": "حملة جديدة",
  "new_notification": "إشعار جديد",
  "new_push_notification": "إشعار دفع جديد",
  "new_verification_sent": "تم إرسال رمز تحقق جديد إلى بريدك الإلكتروني.",
  "news": "أخبار",
  "newsletter": "النشرة",
  "newsletter_desc": "اشترك للحصول على آخر الأخبار",
  "newsletter_only_subscribers": "فقط المشتركين",
  "newsletter_subscribers": "مشتركي النشرة الإخبارية",
  "next": "التالي",
  "no": "لا",
  "noAccount": "ليس لديك حساب؟",
  "no_articles": "لم يتم العثور على مقالات",
  "no_bookings": "لم يتم العثور على حجوزات",
  "no_campaigns": "لا توجد حملات",
  "no_data": "لا توجد بيانات متاحة",
  "no_items": "لم يتم العثور على عناصر",
  "no_linked_campaign": "لا توجد حملة مرتبطة",
  "no_notifications": "لا توجد إشعارات",
  "no_results": "لا توجد نتائج",
  "no_scheduled_posts": "لا مشاركات مجدولة حتى الآن",
  "no_sent_notifications": "لا توجد إشعارات مرسلة",
  "none": "لا شيء",
  "note": "ملاحظة",
  "notification_body": "محتوى الإشعار",
  "notification_title": "عنوان الإشعار",
  "notifications": "الإشعارات",
  "of": "من",
  "off": "إيقاف",
  "offline": "غير متصل",
  "on": "تشغيل",
  "one_time": "دفعة واحدة",
  "online": "متصل",
  "open_rate": "معدل الفتح",
  "optional": "اختياري",
  "options": "الخيارات",
  "orContinueWith": "أو الاستمرار مع",
  "or_continue_with": "أو المتابعة باستخدام",
  "order": "طلب",
  "other": "أخرى",
  "page": "صفحة",
  "part_time": "دوام جزئي",
  "password": "كلمة المرور",
  "paste": "لصق",
  "pause": "إيقاف مؤقت",
  "payment_error": "خطأ في الدفع",
  "payment_processing": "جاري معالجة الدفع...",
  "payment_success": "تم الدفع بنجاح!",
  "payment_thank_you": "شكراً لشرائك!",
  "pending": "قيد الانتظار",
  "pending_approval": "في انتظار الموافقة",
  "per_month": "/شهر",
  "per_page": "لكل صفحة",
  "percentage": "النسبة المئوية",
  "performance": "الأداء",
  "phone": "الهاتف",
  "platforms": "المنصات",
  "politics": "سياسة",
  "poll_results": "النتائج",
  "poll_total_votes": "إجمالي الأصوات",
  "poll_vote": "تصويت",
  "popular": "الأكثر شعبية",
  "post_comment": "أضف تعليقًا",
  "post_error": "خطأ في النشر",
  "post_job": "أعلن عن وظيفة",
  "post_now": "نشر الآن",
  "powered_by": "مشغل بواسطة",
  "premium": "متميز",
  "preview": "معاينة",
  "previous": "السابق",
  "price": "السعر",
  "privacy": "الخصوصية",
  "privacy_title": "سياسة الخصوصية",
  "proceed_to_payment": "الانتقال إلى الدفع",
  "profile": "الملف الشخصي",
  "profile_admin_access": "الوصول السريع للإدارة",
  "profile_analytics": "التحليلات",
  "profile_articles": "المقالات",
  "profile_dashboard": "لوحة التحكم",
  "profile_edit": "تحرير الملف الشخصي",
  "profile_verified": "تم التحقق من الملف الشخصي!",
  "promo_success": "تم تطبيق الرمز الترويجي بنجاح!",
  "promote_job": "ترقية الوظيفة",
  "publish": "نشر",
  "published": "نُشر",
  "published_date": "تاريخ النشر",
  "push_notifications": "إشعارات الدفع",
  "read": "مقروء",
  "read_more": "اقرأ المزيد",
  "real_estate": "عقارات",
  "recent": "الأحدث",
  "recipes_add_first": "أضف وصفتك الأولى",
  "recipes_browse_all": "تصفح جميع الوصفات",
  "recipes_category": "الفئة",
  "recipes_cook_time": "وقت الطهي",
  "recipes_easy": "سهل",
  "recipes_featured": "الوصفات المميزة",
  "recipes_filters": "فلاتر",
  "recipes_ingredient": "مكون",
  "recipes_ingredients": "المكونات",
  "recipes_instructions": "التعليمات",
  "recipes_latest": "أحدث الوصفات",
  "recipes_most_popular": "الوصفات الأكثر شيوعًا",
  "recipes_prep_time": "وقت التحضير",
  "recipes_search": "البحث في الوصفات...",
  "recipes_servings": "حصص",
  "recipes_title": "وصفات",
  "recommended": "موصى به",
  "refresh": "تحديث",
  "region": "المنطقة",
  "register": "تسجيل",
  "reject": "رفض",
  "rejected": "مرفوض",
  "related_articles": "مقالات ذات صلة",
  "remote": "عن بعد",
  "remove": "إزالة",
  "report": "تقرير",
  "reports": "تقارير",
  "reposting_rules_title": "قواعد إعادة النشر",
  "required": "مطلوب",
  "reset": "إعادة تعيين",
  "restore": "استعادة",
  "results": "النتائج",
  "resume": "استئناف",
  "revision_restored": "تم استعادة المراجعة!",
  "salary": "الراتب",
  "salary_max": "الراتب الأقصى",
  "salary_min": "الحد الأدنى للراتب",
  "save": "حفظ",
  "saved_jobs": "الوظائف المحفوظة",
  "saved_successfully": "تم الحفظ بنجاح",
  "schedule": "جدول",
  "scheduled": "مجدول",
  "science": "علوم",
  "search": "بحث...",
  "search_articles": "بحث في المقالات...",
  "search_placeholder": "بحث...",
  "search_results_for": "نتائج البحث لـ",
  "seconds": "ثواني",
  "see_all": "عرض الكل",
  "select": "اختيار",
  "select_all": "تحديد الكل",
  "select_format": "اختر التنسيق",
  "seller": "البائع",
  "send_campaign": "إرسال الحملة",
  "sent": "مرسل",
  "sent_campaigns": "الحملات المرسلة",
  "services": "خدمات",
  "settings": "الإعدادات",
  "share": "مشاركة",
  "showing": "عرض",
  "signIn": "تسجيل الدخول",
  "signOut": "تسجيل الخروج",
  "site_name": "Croatia Times",
  "site_subtitle": "كرواتيا اليوم",
  "six_digit_code": "رمز من 6 أرقام",
  "social_media": "وسائل التواصل الاجتماعي",
  "social_scheduler": "جدولة التواصل الاجتماعي",
  "sort": "فرز",
  "sponsored_marketplace_title": "السوق المدعوم",
  "sports": "رياضة",
  "stable": "مستقر",
  "start": "بدء",
  "start_date": "تاريخ البدء",
  "static_about_contact": "للاستفسارات التحريرية، الإعلانات أو المعلومات العامة، قم بزيارة",
  "static_about_contact_page": "صفحة الاتصال",
  "static_about_contact_title": "اتصل",
  "static_about_lead": "Croatia Times هو بوابة إخبارية مستقلة تقدم لك أحدث الأخبار والتحليلات والتعليقات والقصص من كرواتيا والمنطقة. نحن جزء من عائلة الوسائط e-mina.eu، بنفس الفريق والقيم.",
  "static_about_mission": "نحن ملتزمون بتقديم صحافة دقيقة وفي الوقت المناسب وبجودة تخدم المصلحة العامة. يتكون فريق التحرير لدينا من صحفيين ذوي خبرة ومعرفة عميقة بالشؤون الكرواتية والإقليمية.",
  "static_about_mission_title": "مهمتنا",
  "static_about_publisher": "Liber Nostra d.o.o. هي الناشر لبوابة Croatia Times و e-mina.eu. تتخصص الشركة في وسائل الإعلام الرقمية وبوابات الأخبار التي تركز على السوق الكرواتي.",
  "static_about_publisher_title": "الناشر",
  "static_about_standards": "تلتزم Croatia Times بأعلى معايير الصحافة. نحن نتحقق من تقاريرنا، نوضح بوضوح التعليقات والتحليلات، ونقوم بتصحيح الأخطاء بسرعة وشفافية.",
  "static_about_standards_title": "معايير التحرير",
  "static_about_team": "خلف Croatia Times يقف فريق من المحترفين الإعلاميين ذوي الخبرة والصحفيين والمحررين والخبراء الفنيين الذين يعملون على تطوير المنصة وجودة المحتوى. فريقنا هو نفس الفريق الذي يقف خلف البوابة الناجحة e-mina.eu - وكالة الأنباء الدولية.",
  "static_about_team_title": "الفريق",
  "static_about_title": "معلومات عنا - Croatia Times",
  "static_bug_description": "وصف الخطأ",
  "static_bug_description_placeholder": "وصف ما حدث وكيفية استنساخ المشكلة...",
  "static_bug_intro": "هل وجدت شيئًا لا يعمل بشكل صحيح؟ أعلمنا وسنقوم بإصلاحه على الفور.",
  "static_bug_page_url": "رابط الصفحة (حيث حدث الخطأ)",
  "static_bug_screenshot": "لقطة شاشة (اختياري)",
  "static_bug_submit": "إرسال تقرير الخطأ",
  "static_bug_submitting": "جارٍ التقديم...",
  "static_bug_thanks": "شكرًا لك على تقريرك! سنحقق في المشكلة ونقوم بإصلاحها.",
  "static_bug_title": "الإبلاغ عن خطأ",
  "static_commenting_intro": "نرحب بالنقاش البناء. للحفاظ على قسم التعليقات لدينا إيجابيًا ومنتجًا، يرجى اتباع هذه القواعد:",
  "static_commenting_login": "للتعليق، يجب أن تكون مسجلاً وقيد تسجيل الدخول إلى Croatia Times.",
  "static_commenting_rule_1": "كن محترمًا ومهذبًا مع المستخدمين الآخرين وموضوعات المقالات",
  "static_commenting_rule_2": "لا للخطابات الكراهية، العنصرية، التمييز على أساس الجنس، أو أي نوع من أنواع التمييز",
  "static_commenting_rule_3": "لا للبريد العشوائي، الإعلان، أو المحتوى الترويجي",
  "static_commenting_rule_4": "لا للمعلومات المضللة أو نشر الادعاءات غير المؤكدة",
  "static_commenting_rule_5": "لا للهجمات الشخصية أو المضايقات",
  "static_commenting_rule_6": "ابقَ على الموضوع وساهم في المحادثة",
  "static_commenting_rule_7": "لا للمعلومات الشخصية أو السرية عن أطراف ثالثة",
  "static_commenting_title": "قواعد التعليق",
  "static_commenting_violation": "قد تتم إزالة التعليقات التي تنتهك هذه القواعد دون إشعار. قد يتم حظر المخالفين المتكررين بشكل دائم.",
  "static_contact_email": "البريد الإلكتروني",
  "static_contact_message": "الرسالة",
  "static_contact_message_placeholder": "رسالتك...",
  "static_contact_name": "الاسم",
  "static_contact_name_placeholder": "اسمك",
  "static_contact_send": "إرسال الرسالة",
  "static_contact_sending": "جاري الإرسال...",
  "static_contact_sent_desc": "سنعود إليك في غضون 24 ساعة.",
  "static_contact_sent_title": "تم إرسال الرسالة!",
  "static_contact_subject": "الموضوع",
  "static_contact_subject_placeholder": "كيف يمكننا مساعدتك؟",
  "static_contact_title": "اتصل بنا",
  "static_cookies_advertising_text": "قد نستخدم ملفات تعريف الارتباط من Google AdSense لعرض الإعلانات ذات الصلة.",
  "static_cookies_advertising_title": "ملفات تعريف الارتباط الإعلانية",
  "static_cookies_analytics_text": "يساعدنا Google Analytics في فهم كيفية استخدام الزوار لموقعنا. يتم إخفاء البيانات حيثما أمكن.",
  "static_cookies_analytics_title": "ملفات تعريف الارتباط التحليلية",
  "static_cookies_managing_text": "يمكنك التحكم في ملفات تعريف الارتباط من خلال إعدادات المتصفح الخاصة بك. قد يؤثر تعطيل ملفات تعريف الارتباط الضرورية على وظيفة الموقع.",
  "static_cookies_managing_title": "إدارة ملفات تعريف الارتباط",
  "static_cookies_necessary_text": "هذه مطلوبة لوظيفة الموقع (جلسات تسجيل الدخول، تفضيلات الثيم). لا يمكن تعطيلها.",
  "static_cookies_necessary_title": "ملفات تعريف الارتباط الضرورية",
  "static_cookies_title": "سياسة ملفات تعريف الارتباط",
  "static_cookies_types_title": "أنواع ملفات تعريف الارتباط التي نستخدمها",
  "static_cookies_what_text": "ملفات تعريف الارتباط هي ملفات نصية صغيرة توضع على جهازك عند زيارة موقع ويب. تساعد الموقع على تذكر تفضيلاتك وفهم كيفية استخدامك له.",
  "static_cookies_what_title": "ما هي ملفات تعريف الارتباط",
  "static_imprint_ads_email": "البريد الإلكتروني (الإعلانات):",
  "static_imprint_ai_notice": "يتم إنشاء بعض المحتوى باستخدام تقنية الذكاء الاصطناعي. أبلغ عن الأخطاء أو المحتوى غير المناسب إلى",
  "static_imprint_contact": "اتصال",
  "static_imprint_copyright": "حقوق النشر",
  "static_imprint_copyright_text": "كل المحتوى المنشور على Croatia Times محمي بموجب حقوق النشر. تحتفظ Liber Nostra d.o.o. بجميع الحقوق المتعلقة بالنصوص والصور والمحتويات المتعددة الوسائط المنشورة على هذا الموقع. تتوفر معلومات مفصلة عن قواعد إعادة نشر المحتوى على",
  "static_imprint_ct_desc": "بوابة أخبار Croatia Times",
  "static_imprint_disclaimer": "إخلاء المسؤولية",
  "static_imprint_disclaimer_text": "على الرغم من التحكم الدقيق في المحتوى، فإننا لا نتحمل أي مسؤولية عن الروابط الخارجية. المشغلون هم المسؤولون فقط عن محتواهم.",
  "static_imprint_editorial_email": "البريد الإلكتروني (التحرير):",
  "static_imprint_emina_desc": "وكالة الأنباء الدولية",
  "static_imprint_general_email": "البريد الإلكتروني (الاستفسارات العامة):",
  "static_imprint_last_updated": "آخر تحديث: فبراير 2026",
  "static_imprint_or_via": "أو عبر",
  "static_imprint_publisher": "الناشر",
  "static_imprint_registered": "مسجل في جمهورية كرواتيا",
  "static_imprint_reposting_page": "صفحة قواعد إعادة النشر",
  "static_imprint_responsible": "المسؤول عن المحتوى",
  "static_imprint_responsible_text": "فريق التحرير لـ Croatia Times / Liber Nostra d.o.o.",
  "static_imprint_title": "البصمة",
  "static_imprint_websites": "مواقع الويب",
  "static_privacy_controller": "مراقب البيانات: Liber Nostra d.o.o.",
  "static_privacy_cookies_text": "نحن نستخدم ملفات تعريف الارتباط للوظائف والتحليلات. انظر سياسة ملفات تعريف الارتباط الخاصة بنا للحصول على التفاصيل.",
  "static_privacy_cookies_title": "ملفات تعريف الارتباط",
  "static_privacy_data_text": "نجمع البيانات التي تقدمها مباشرة (الاسم، البريد الإلكتروني عند التسجيل)، بيانات الاستخدام (الصفحات التي تم زيارتها، المقالات التي تم قراءتها)، والبيانات التقنية (عنوان IP، نوع المتصفح).",
  "static_privacy_data_title": "البيانات التي نجمعها",
  "static_privacy_last_updated": "آخر تحديث: يناير 2026",
  "static_privacy_lead": "Croatia Times تحترم خصوصيتك وتلتزم بحماية بياناتك الشخصية.",
  "static_privacy_retention_text": "نحتفظ ببياناتك طالما أن حسابك نشط، أو حسب الحاجة لأغراض قانونية.",
  "static_privacy_retention_title": "الاحتفاظ بالبيانات",
  "static_privacy_rights_text": "لديك الحق في الوصول إلى بياناتك الشخصية، وتصحيحها، أو حذفها. اتصل بنا على",
  "static_privacy_rights_title": "حقوقك",
  "static_privacy_title": "سياسة الخصوصية",
  "static_privacy_usage_text": "نستخدم بياناتك لتقديم خدمة الأخبار لدينا، وتخصيص تجربتك، وإرسال النشرات الإخبارية (بموافقتك)، وتحسين منصتنا.",
  "static_privacy_usage_title": "كيف نستخدم بياناتك",
  "static_reposting_copyright_text": "جميع المحتويات المنشورة على Croatia Times محمية بحقوق الطبع والنشر. تحتفظ Liber Nostra d.o.o. بجميع الحقوق المتعلقة بالنصوص، الصور، والوسائط المتعددة المنشورة على هذا الموقع.",
  "static_reposting_copyright_title": "حقوق الطبع والنشر",
  "static_reposting_permission_text": "للحصول على إذن لإعادة طبع المحتوى، تواصل معنا على",
  "static_reposting_permission_title": "طلبات الإذن",
  "static_reposting_permitted_text": "يمكنك مشاركة روابط مقالاتنا على وسائل التواصل الاجتماعي والمنصات الأخرى. يمكن استخدام اقتباسات قصيرة (حتى فقرتين) مع الإشارة الواضحة ووضع رابط للمقال الأصلي.",
  "static_reposting_permitted_title": "الاستخدام المسموح",
  "static_reposting_prohibited_text": "يحظر إعادة طبع المقالات بشكل كامل دون إذن كتابي. لا يجوز إعادة إنتاج الصور دون إذن. يحظر تمامًا جمع المحتوى تلقائيًا.",
  "static_reposting_prohibited_title": "الاستخدام المحظور",
  "static_reposting_title": "قواعد إعادة النشر",
  "static_submit_news_details": "تفاصيل القصة",
  "static_submit_news_details_placeholder": "صف الأخبار...",
  "static_submit_news_file_limit_error": "يتجاوز الملف الحد المسموح به",
  "static_submit_news_headline": "عنوان الأخبار",
  "static_submit_news_intro": "هل لديك أخبار؟ أرسلها هنا وسيراجعها فريق التحرير لدينا.",
  "static_submit_news_limit": "نقبل الصور والفيديوهات حتى",
  "static_submit_news_photos": "صور / فيديو (حتى",
  "static_submit_news_send": "إرسال الأخبار",
  "static_submit_news_sending": "جارٍ الإرسال...",
  "static_submit_news_source": "المصدر / المرجع (اختياري)",
  "static_submit_news_source_placeholder": "رابط أو مرجع",
  "static_submit_news_thanks": "شكرًا لك على تقديمك! سيراجع فريقنا ذلك قريبًا.",
  "static_submit_news_title": "أرسل أخبارك",
  "static_submit_news_your_name": "اسمك",
  "status": "الحالة",
  "stop": "إيقاف",
  "submit": "إرسال",
  "submitNews": "إرسال خبر",
  "submit_bug_title": "إرسال تقرير عن خطأ",
  "submit_news": "إرسال خبر",
  "submit_news_title": "إرسال الأخبار",
  "subscribe": "اشترك",
  "subscription": "الاشتراك",
  "subscription_title": "خطط الاشتراك",
  "success": "نجاح",
  "support": "الدعم",
  "tablet": "الأجهزة اللوحية",
  "tags": "العلامات",
  "target_impressions": "الانطباعات المستهدفة",
  "technology": "تكنولوجيا",
  "template": "قالب",
  "templates": "قوالب",
  "terms": "الشروط",
  "thank_you": "شكرا لك",
  "this_month": "هذا الشهر",
  "this_week": "هذا الأسبوع",
  "this_year": "هذا العام",
  "tip": "نصيحة",
  "title": "العنوان",
  "to": "إلى",
  "today": "اليوم",
  "total": "المجموع",
  "translate_all": "ترجمة الكل",
  "translation_status": "حالة الترجمة",
  "translations": "الترجمات",
  "travel": "السفر",
  "trending": "الشائع",
  "try_again": "حاول مجدداً",
  "twitter": "تويتر",
  "two_factor_auth": "المصادقة الثنائية",
  "type": "النوع",
  "ugc_submit": "إرسال المحتوى",
  "ugc_title": "بوابة صحافة المواطن",
  "unique_clicks": "النقرات الفريدة",
  "unique_opens": "الفتحات الفريدة",
  "unknown": "غير معروف",
  "unpublish": "إلغاء النشر",
  "unread": "غير مقروء",
  "update": "تحديث",
  "updated_successfully": "تم التحديث بنجاح",
  "upgrade": "ترقية",
  "upload": "تحميل",
  "users": "المستخدمون",
  "vehicles": "مركبات",
  "verification_code_sent": "تم إرسال رمز التحقق إلى بريدك الإلكتروني!",
  "version": "إصدار",
  "vibeposao": "Times Posao",
  "view": "عرض",
  "view_all": "عرض الكل",
  "views": "مشاهدات",
  "warning": "تحذير",
  "welcome": "مرحبًا",
  "wish_roles": "الأدوار المطلوبة",
  "working_hours_saved": "تم حفظ ساعات العمل!",
  "world": "العالم",
  "write_new_article": "اكتب مقالاً جديداً",
  "yes": "نعم",
  "yesterday": "أمس",
  "your_bookings": "حجوزاتك",
  "youtube": "يوتيوب"
}
